module.exports = __webpack_public_path__ + "img/BRCA4_Plasma.af676e29.png";